import { useState } from "react";
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import taskerAuth from "../../../services/taskerAuth";

function ProfileMenu() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const mobile = taskerAuth.getVendorMobile();
  // Fall back to +91 only when we have no persisted code — for backward
  // compat with sessions that predate the country-code widening.
  const countryCode = taskerAuth.getVendorMobileCountryCode() ?? "+91";
  const initial = "V";

  const handleOpen = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleMyProfile = () => {
    handleClose();
    setDialogOpen(true);
  };

  const handleLogout = () => {
    handleClose();
    taskerAuth.clearTaskerSession();
    navigate("/vendor-onboarding/login", { replace: true });
  };

  const displayMobile = mobile ? `${countryCode} ${mobile}` : "—";

  return (
    <>
      <IconButton
        onClick={handleOpen}
        size="small"
        aria-label="Open profile menu"
      >
        <Avatar
          sx={{
            width: 32,
            height: 32,
            bgcolor: "primary.main",
            fontSize: 14,
          }}
        >
          {initial}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleMyProfile}>My Profile</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>My Profile</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Mobile
          </Typography>
          <Typography variant="body1">{displayMobile}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ProfileMenu;
